import { compose } from "@lululemon/mwa-utils";
import { withRemoteModulePreload } from "./remote-module-preload";
import withLaunchDarklyFeatureFlags from "./with-launch-darkly-feature-flags";
export function withLapel(options) {
    return function(Component) {
        return compose(// Enable SSR preloading of remote modules
        withRemoteModulePreload(options), withLaunchDarklyFeatureFlags(options))(Component);
    };
}

//# sourceMappingURL=with-lapel.js.map